import { api } from "../utils/api";

const getGradeDistribuitionChart = async (studentId, period, type) => {
  const res = await api.get(
    `Academics/student/${studentId}/grade-distribuition`,
    {
      params: { filter: { schoolYear: new Date().getFullYear(), period, type } }
    }
  );
  return res.data;
};

const getOverallPerformanceChart = async (studentId, period) => {
  const res = await api.get(
    `Academics/student/${studentId}/overall-performance`,
    {
      params: { filter: { schoolYear: new Date().getFullYear(), period } }
    }
  );
  return res.data;
};

const getPeriodPerformance = async studentId => {
  const res = await api.get(
    `Academics/student/${studentId}/period-performance`,
    {
      params: { filter: { schoolYear: new Date().getFullYear() } }
    }
  );
  return res.data;
};

const getChartStages = async studentId => {
  const res = await api.get(
    `Academics/student/${studentId}/statistics-stages`,
    {
      params: { filter: { schoolYear: new Date().getFullYear() } }
    }
  );
  return res.data;
};

export default {
  getGradeDistribuitionChart,
  getOverallPerformanceChart,
  getPeriodPerformance,
  getChartStages
};
